const handleTesterSubmit = async(event) => {
  event.preventDefault();

  event.submitter.disabled = true;

  const getResponse = await fetch(window.Shopify.routes.root + 'cart.js');
  const currentCart = await getResponse.json();
  const items = currentCart.items;

  const testerId = event.target.dataset.variantid;
  let isTesterInCart = false;

  items.forEach(item => {
    if(item.id.toString() === testerId.toString()) {
      isTesterInCart = true;
    }
  });
  if(isTesterInCart) {
    event.submitter.disabled = true;
    return;
  }
  const formData = new FormData(event.target);


  try {
    const addResponse = await fetch(theme.routes.cartAdd, {
      method: 'POST',
       headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });
    if(addResponse.status === 200) {
      event.target.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      event.submitter.value = event.submitter.dataset.addedtext;

      if (theme.settings.afterAddToCart === 'notification') {
          const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
          notification.dataset.productTitle = data.product_title;
          let notificationContainer = document.querySelector('.pageheader--sticky');
          if (!notificationContainer) {
            notificationContainer = document.querySelector('body');
          }
          notificationContainer.appendChild(notification);
        } else if (theme.settings.afterAddToCart === 'drawer') {
          document.querySelector('.js-cart-drawer').open(event.target.submitBtn);
        }
    }
    else {
      event.submitter.disabled = false;
      throw new Error('Adding tester to cart failed');
    }
  }
  catch(error) {
    console.log(error);
  }

  
  
}

const testerForm = document.querySelector('.tester-add-to-cart .tester-form');
if (testerForm) {
  testerForm.addEventListener('submit', handleTesterSubmit);
}